module.exports = __webpack_public_path__ + "img/shequnlingxiu.41352138.png";